// Context con el "entorno" que necesitan las tool cards del agente para
// abrir flujos reales (p. ej. crear/subir un modelo desde el chat):
//   • userId     — id_auth del usuario (webhook procesar_modelo_propio).
//   • companyId  — id_company (guardado del modelo).
//   • refreshModels — refresca la lista de modelos del padre tras crear uno.
//
// Lo provee InterfazV2 con los valores que ya tiene (userAuthId,
// userCompanyId, refreshUserModels).

import { createContext, useContext } from 'react';

export interface AgentEnv {
  userId: string | null;
  companyId: string | null;
  refreshModels: () => void;
}

export const AgentEnvContext = createContext<AgentEnv>({
  userId: null,
  companyId: null,
  refreshModels: () => {},
});

export const useAgentEnv = (): AgentEnv => useContext(AgentEnvContext);
